import { genReplaceEmpty } from '../../../utils/helper'
import { AlmacenInputProps, AlmacenOutputProps } from '../interfaces'

export const almacenActualizarComposeService = (
  input: AlmacenInputProps,
): AlmacenInputProps => {
  return {
    codigoAlmacen: genReplaceEmpty(input.codigoAlmacen, ''),
    nombre: genReplaceEmpty(input.nombre, ''),
    ubicacion: genReplaceEmpty(input.ubicacion, ''),
    codigoSucursal: genReplaceEmpty(input.sucursal, ''),
    sucursal: input.sucursal,
  }
}
